import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function AboutPage() {
  useDocumentTitle({
    title: "关于我们-屁屁影院",
    description: "了解屁屁影院的网站定位、内容说明与版权声明。屁屁影院致力于为用户提供清晰快捷的影视发现与浏览体验。",
    keywords: "屁屁影院,关于我们,影视平台,版权声明",
  });

  const sections = [
    {
      icon: "ri-film-line",
      title: "网站介绍",
      content: [
        "屁屁影院是一个现代门户风格的影视聚合平台，专注为用户提供最新电影与电视剧的发现与浏览服务。我们汇集动作、科幻、悬疑、爱情、喜剧等多种类型资源，帮助影视爱好者、追剧用户与休闲娱乐用户快速找到想看的内容。",
        "通过分类频道、多维筛选、关键词搜索与个性化推荐，我们希望让每一次找片都变得简单、快捷、愉悦。",
      ],
    },
    {
      icon: "ri-copyright-line",
      title: "使用与版权声明",
      content: [
        "本站所有影视名称、简介及相关信息均为示范虚构内容，仅用于网站功能与界面的演示展示，不指向任何真实影视作品。",
        "本站播放按钮为前端功能演示，暂不提供真实的视频播放、下载或传播服务。若未来接入相关内容，将严格遵守相关法律法规与版权要求。",
        "用户应合理使用本站功能，本地的收藏记录仅保存在您当前使用的浏览器中，清除浏览器数据后将不再保留。",
      ],
    },
    {
      icon: "ri-question-answer-line",
      title: "常见问题",
      content: [
        "为什么点击播放没有反应？——目前播放为前端演示，按钮会提示“即将支持播放功能”。",
        "收藏会同步到其他设备吗？——不会，收藏仅保存在本地浏览器，无需登录即可使用。",
        "如何快速找到某部影片？——可通过顶部搜索框输入片名、导演或演员，或进入对应分类频道筛选。",
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />

      <main>
        <section className="border-b border-background-200/60 bg-background-100/40 px-4 py-14 md:px-6 md:py-16">
          <div className="mx-auto max-w-[900px] text-center">
            <span className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-500 text-background-50">
              <i className="ri-movie-2-line text-3xl" />
            </span>
            <h1 className="text-3xl font-bold text-foreground-950 md:text-4xl">关于屁屁影院</h1>
            <p className="mt-3 text-sm leading-relaxed text-foreground-500 md:text-base">
              让发现好片，变成一件轻松愉快的小事。
            </p>
          </div>
        </section>

        <div className="mx-auto max-w-[900px] px-4 py-12 md:px-6 md:py-16">
          <div className="flex flex-col gap-8">
            {sections.map((s) => (
              <section key={s.title} className="rounded-lg border border-background-200/60 bg-background-100 p-5 md:p-7">
                <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500/15 text-accent-400">
                    <i className={s.icon} />
                  </span>
                  {s.title}
                </h2>
                <div className="mt-4 space-y-3">
                  {s.content.map((p, i) => (
                    <p key={i} className="text-sm leading-relaxed text-foreground-500">{p}</p>
                  ))}
                </div>
              </section>
            ))}

            <section className="rounded-lg border border-background-200/60 bg-background-100 p-5 md:p-7">
              <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500/15 text-accent-400">
                  <i className="ri-customer-service-2-line" />
                </span>
                联系方式
              </h2>
              <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div className="flex items-center gap-3 rounded-md bg-background-200/40 px-4 py-3">
                  <i className="ri-mail-line text-xl text-accent-400" />
                  <div>
                    <p className="text-xs text-foreground-500">联系邮箱</p>
                    <p className="text-sm text-foreground-950">hello@pipi-cinema.example.com</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 rounded-md bg-background-200/40 px-4 py-3">
                  <i className="ri-time-line text-xl text-accent-400" />
                  <div>
                    <p className="text-xs text-foreground-500">服务时间</p>
                    <p className="text-sm text-foreground-950">工作日 9:00 - 18:00</p>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <div className="mt-10 flex flex-wrap gap-3">
            <Link
              to="/"
              className="whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-accent-600"
            >
              返回首页
            </Link>
            <Link
              to="/search"
              className="whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-semibold text-foreground-950 hover:bg-background-100"
            >
              去搜索影视
            </Link>
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}